export const activeSurvey = () => ({
  displayOptionsMap: {},
  displayOptions: [],
  sections: []
});

export const auth = () => ({
  authCheckInterval: 10,
  authCheckTime: null,
  adminOverride: false,
  user: {
    username: null,
    email: null,
    emailConfirmed: false,
    roles: []
  },
  instanceInfo: {
    displayOptions: [],
    sections: []
  }
});
